<script>
import { services } from '@utils/common-services'
export default {
  components: {},
  props: {
    deleteRole: {
      type: Boolean,
      default() {
        return false
      },
    },
    editRole: {
      type: Boolean,
      default() {
        return false
      },
    },
  },
  data() {
    return {
      trySpin: false,
      roleName: null,
      permissions: null,
      permission: null,
      message: null,
      errorShow: false,
      isBusy: null,
      deleteId: null,
      fields: ['name'],
    }
  },
  computed: {
    placeholders() {
      return {
        roleName: 'Role name',
      }
    },
  },
  beforeMount() {
    if (this.editRole || this.deleteRole) {
      this.fields.push('actions')
    }
    this.getRoles()
  },
  beforeDestroy() {
    // this.$store.commit('jv/clearRecords', { _jv: { type: 'role' } })
  },
  methods: {
    edit(id) {
      this.$emit('edit', id)
    },
    deleteItem(id) {
      this.$bvModal.show('deleteRole')
      this.deleteId = id
    },
    deleteRecord() {
      var id = this.deleteId
      this.$store
        .dispatch('jv/delete', [
          'role',
          {
            url: '/accounts/roles/' + id,
            headers: services.getHeaderAuthorization(),
          },
        ])
        .then(() => {})
        .catch((err) => {
          this.message = err.data.error.detail
          this.errorShow = true
          this.$bvToast.show('deleteRecord')
          this.$bvModal.hide('deleteRole')
          var parent = this
          setTimeout(() => {
            parent.errorShow = false
            parent.$bvToast.hide('deleteRecord')
            parent.message = null
          }, 1000)
        })
      this.$store.commit('jv/deleteRecord', {
        _jv: { type: 'role', id: id },
      })
      this.message = 'Requested role is deleted'
      this.$bvModal.hide('deleteRole')
      this.$bvToast.show('deleteRecord')
      var parent = this
      setTimeout(() => {
        parent.errorShow = false
        parent.$bvToast.hide('deleteRecord')
        parent.message = null
      }, 1000)
      this.setPermission()
    },
    getRoles() {
      this.isBusy = true
      this.$store
        .dispatch('jv/get', [
          'role',
          {
            url: '/accounts/roles',
            headers: services.getHeaderAuthorization(),
          },
        ])
        .then((response) => {
          this.setPermission()
          this.isBusy = false
        })
    },
    setPermission() {
      this.permissions = []
      var check = this.$store.getters['jv/get']('role')

      var id = Object.keys(check)

      for (var i = 0; i < id.length; i++) {
        this.permissions.push({ name: check[id[i]].name, id: id[i] })
      }
    },
  },
}
</script>
<template>
  <div>
    <div>
      <b-table
        v-if="permissions === null"
        :items="permissions"
        :busy="isBusy"
        class="mt-3"
        outlined
      >
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
      </b-table>
      <b-table
        v-else
        :items="permissions"
        :fields="fields"
        responsive="sm"
        borderless
        :class="$style.rolesTable"
        head-variant="light"
      >
        <template v-if="editRole || deleteRole" v-slot:cell(actions)="row">
          <b-button
            v-if="editRole"
            size="sm"
            class="mr-2 mb5"
            :class="$style.iconBtn"
            @click="edit(row.item.id)"
          >
            <BIcon icon="pencil" class="mr5"></BIcon>Edit
          </b-button>
          <b-button
            v-if="deleteRole"
            size="sm"
            class="mr-2 mb5"
            :class="$style.iconBtn"
            @click="deleteItem(row.item.id)"
          >
            <BIcon icon="trash" class="mr5"></BIcon>Delete
          </b-button>
        </template>
      </b-table>
    </div>
    <div :class="$style.toasterMainWrap">
      <b-toast id="deleteRecord" solid no-auto-hide>
        <div
          class="d-flex"
          :class="[$style.loginToasterWraper, $style.success]"
        >
          <div :class="$style.toasterLeft">
            <BIcon
              icon="chat-square-dots-fill"
              :class="$style.toasterIcon"
            ></BIcon>
          </div>
          <div :class="$style.toasterRight">
            <strong class="mr-auto" :class="$style.toasterHeader"
              >Notice!</strong
            >
            <p :class="$style.toasterContent">{{ message }}</p>
          </div>
          <div class="clear"></div>
        </div>
      </b-toast>
    </div>
    <div>
      <b-modal
        id="deleteRole"
        centered
        title="BootstrapVue"
        hide-header
        hide-footer
        size="md"
        :class="$style.modalOverall"
      >
        <div :class="[$style.modalWraper, $style.planeModal]">
          <div :class="$style.modalHeader">
            <h3 :class="$style.modalTitle">Confirmation</h3>
            <span :class="$style.modalIcon"></span>
          </div>
          <div class="clear"></div>
          <div :class="$style.modalBody">
            <p :class="$style.modalText">Do you want to delete this record?</p>
            <div class="clear"></div>
            <div :class="[$style.buttonWrapper]" class="tc mt30">
              <button
                type="button"
                class="buttonCommon buttonCancel button mr10"
                @click="$bvModal.hide('deleteRole')"
              >
                Cancel
              </button>
              <button
                class="buttonCommon buttonPrimary button"
                type="button"
                @click="deleteRecord"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<style lang="scss" module>
@import '@design';

// Modal
.modalOverall {
  padding: 0;
}
.modalWraper {
  .modalHeader {
    padding: 25px 30px;
    background: #fafafa;
    border-bottom: 1px solid #ebebeb;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  .modalTitle {
    float: left;
    margin: 5px 0 0 0;
    font-family: 'OpenSansRegular', Helvetica Neue, sans-serif,
      Apple Color Emoji;
    font-size: 20px;
    color: #808183;
  }

  .modalBody {
    padding: 25px 30px 40px 30px;
  }

  .modalfooter {
    padding-top: 30px;
    padding-bottom: 10px;
  }

  &.planeModal {
    .modalHeader {
      padding: 25px 30px 5px 30px;
      background: #fff;
      border: 0;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
    }
    .modalIcon {
      display: block;
      width: 100px;
      height: 100px;
      margin: 20px auto;
      background: url('~@assets/images/information.png') no-repeat;
      transform: scale(0.9);
      transform-origin: top;
    }
    .modalTitle {
      float: none;
      text-align: center;
    }
    .modalText {
      font-family: 'RobotoRegular', Helvetica Neue, sans-serif,
        Apple Color Emoji;
      font-size: 15px;
      line-height: 20px;
      color: #818284;
      text-align: center;
    }
    .modalBody {
      padding: 0 30px 40px 30px;
    }
  }
}
// Modal

.rolesTable {
  display: block;
  max-width: 700px;
  overflow: hidden;
  border: 1px solid #dee2e6;
  border-radius: 10px;

  table {
    border: 0 !important;
  }

  th {
    font-family: 'ProductSansRegular', Helvetica Neue, sans-serif,
      Apple Color Emoji !important;
    font-size: 16px !important;
    color: #4b545e !important;
    background-color: #f9f9fb !important;
    border: none !important;
    border-bottom: 1px solid #e8e8e8 !important;
  }

  td {
    padding: 11px 15px !important;
    font-family: 'ProductSansRegular', Helvetica Neue, sans-serif,
      Apple Color Emoji !important;
    font-size: 14px !important;
    color: #4b545e !important;
  }

  tr:nth-child(even) {
    background-color: #f9f9fb;
  }
}

.iconBtn {
  display: inline-block;
  padding: 4px 14px !important;
  font-family: 'RobotoRegular', Helvetica Neue, sans-serif, Apple Color Emoji !important;
  font-size: 12px !important;
  color: #aaacb0 !important;
  background: #fff !important;
  border: 1px solid #aaacb0 !important;
  border-radius: 50px !important;

  &.agreed {
    color: #60e8bb;
    background: #fff;
    border-color: #60e8bb;
  }
}
</style>
